'use client';
import React from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { BlogPostFieldsFragment } from '@/gql/__generated/graphql.types';

import { BlogPageTemplate } from '../pages/BlogPageTemplate';

type BlogPageTemplateProps = {
  blogData: BlogPostFieldsFragment;
};

export default function BlogPostPreviewWrapper({ blogData }: BlogPageTemplateProps) {
  const liveCollection = useContentfulLiveUpdates(blogData);

  return <BlogPageTemplate blog={liveCollection} />;
}
